import { COSMETICS, LEAGUES, unlocked, type Reached } from '@il-colpo/meta/progress';
import type { PlayerProgress } from './types.ts';

/** What a player has reached, to ask which cosmetics their level, trophies and league open. */
export function reachedBy(progress: PlayerProgress): Reached {
  const thief = progress.ratings.find((r) => r.kind === 'thief');
  const leagueRank =
    thief?.placed && thief.league ? LEAGUES.findIndex((l) => l.id === thief.league) : -1;
  return {
    level: progress.level.level,
    trophies: new Set(progress.trophies),
    leagueRank,
  };
}

/** The ids of the cosmetics a player has: those the server gave, and any the rules open now. */
export function ownedCosmetics(progress: PlayerProgress): Set<string> {
  const reached = reachedBy(progress);
  const owned = new Set(progress.inventory);
  for (const c of COSMETICS) if (unlocked(c, reached)) owned.add(c.id);
  return owned;
}
